import { Routes } from "@angular/router";

import { SignUpFailedGuard } from "../../features/signUp/services/signup-failed-guard.guard";
import { SignUpEntryComponent } from "../../features/signUp/signupEntry/signup-entry.component";
import { SignUpDomainComponent } from "../../features/signUp/signupDomain/signup-domain.component";
import { SignUpProfileComponent } from "../../features/signUp/signupProfile/signup-profile.component";

export const SignupRoutes: Routes = [
  {
    path: "",
    redirectTo: "signup",
    pathMatch: "full"
  },
  {
    path: "signup",
    component: SignUpEntryComponent,
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "signup-domain"
      },
      {
        path: "signup-domain",
        canActivate: [SignUpFailedGuard],
        component: SignUpDomainComponent
      },
      {
        path: "signup-profile",
        canActivate: [SignUpFailedGuard],
        component: SignUpProfileComponent
      }
      // {
      //   path: "signup-add-users",
      //   canActivate: [SignUpSuccessGuard],
      // },
    ]
  },
  {
    path: "**",
    redirectTo: "signup"
  }
];
